
  import { Component, Vue, Watch } from 'vue-property-decorator';

  import Spinner from '@/components/Spinner.vue';

  @Component({
    components: {
      Spinner,
    },
  })
  export default class Header extends Vue {
    // props
    // data
    isLoading = true;
    isTooltipShow = false;
    isSignInShow = false;
    avatar = '';

    // methods

    // watch
    @Watch('$store.state.currentUser.token', { deep: true })
    isLoginWatch(newVal: string): void {
      this.isLoading = newVal === undefined;

      if (newVal.length > 0) {
        this.avatar = this.$store.state.currentUser.avatar;
      } else {
        this.avatar = '';
      }
    }
    @Watch('$route.fullPath', { deep: true, immediate: true })
    routerWatch(newVal: string): void {
      this.isSignInShow = newVal.includes('activity');
    }
  }
